import React from 'react';
import K from '~/k';

import { View, TouchableOpacity, Image } from 'react-native';
import { Link, Text, Label } from '@symbolic/rn-lib';

export default class GetDisclaimer extends React.PureComponent {
  render() {
    var { orgId, disclaimerType } = this.props;
    var disclaimers;

    if (orgId === 850) {
      var style = {
        section: {
          marginBottom: K.margin * 3
        },
        pageTitle: {
          opacity: 0.6,
          marginBottom: K.margin * 4,
        },
        sectionTitle: {
          fontWeight: 'bold',
          marginBottom: K.margin / 2
        },
        orderedList: {
          margin: 0,
          padding: 0,
          listStylePosition: 'inside'
        },
        orderedListItem: {
          marginBottom: 0,
          fontWeight: 'bold'
        },
        unorderedList: {
          margin: 0,
          paddingLeft: 16
        },
        unorderedListItem: {
          margin: 0,
        }
      };

      disclaimers = {
        graphicDisclaimer:
          'Plate renderings are provided for coordination purposes and do not represent an exact or binding match of physical products.  We encourage you to view product images for the most accurate graphic examples.',
        generalProductDisclaimer:
          'Configurations and details offered in the configurator represent the most frequently used, though nonexhaustive, options.  For any elements that you wish to achieve but do not see, please contact Meljac North America.',
        backBoxDisclaimer:
          'NOTE: Meljac back boxes are not included on this quote. Please generate a separate quote from the back box section of stocked products. Back boxes are quoted separately in order to allow for purchasing/rough-in prior to order confirmation.',
        engravingDisclaimer:
          'Renderings are provided for coordination purposes and do not represent an exact or binding match of physical products. Please view product images for the most accurate graphic examples.',
        termsAndConditionsDisclaimerPage1: (
          <View>
            <Text style={{...K.fonts.pageHeader, marginBottom: K.margin}}>MELJAC NORTH AMERICA</Text>
            <Text style={{...style.pageTitle, opacity: 1}}>TERMS AND CONDITIONS OF SALE - 2025</Text>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>1. PRODUCT INFORMATION</Text>
              <Text>Keypad push buttons and toggles sold by Meljac North America are intended for interior, low-voltage applications only. UL listings do not cover line-voltage switching. Meljac North America is not responsible for any keypad installations that involve non-line voltage systems or components. Our warranty and support are limited to keypads installed according to their intended use and in compliance with low voltage specifications. Our keypads are rated for interior use only and are not designed for exterior applications.</Text>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>2. ORDER PROCESS</Text>
              <ol type="a" style={{...style.orderedList}}>
                <li style={{...style.orderedListItem}}>Quoting</li>
                <div>Clients should use the Meljac North America partner portal and configurator to generate and maintain records of all quotes and orders.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Responsibility for Approved Drawings</li>
                <div>It is the responsibility of the purchaser to review and approve all drawings and quotes provided by Meljac North America prior to production. Meljac North America is not liable for any errors or omissions in the drawings once they have been approved by the purchaser.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Order Changes</li>
                <div>Any requests for changes to an order must be submitted within 48 hours of placing the order and paying the deposit. Meljac North America will make reasonable efforts to accommodate change requests made within this timeframe, but changes are subject to feasibility and availability.</div>
              </ol>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>3. LEAD TIMES</Text>
              <Text>
                Lead times for made-to-order items are provided as an estimate and subject to change. Meljac North America will make reasonable efforts to meet the estimated delivery dates but is not liable for any delays or failure to deliver within the estimated timeframe. For stock orders (e.g., non-custom back boxes), products will ship within three business  days from payment.
              </Text>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>4. PAYMENT TERMS</Text>
              <ol type="a" style={{...style.orderedList}}>
                <li style={{...style.orderedListItem}}>Pricing</li>
                <div>Prices may be subject to change without notice. In the instance of a price increase Meljac North America will provide a minimum of 15 days of warning prior to a price increase to allow for any quote to be placed at the existing price.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Made-to-Order Products</li>
                <div>A 50% deposit is required to initiate production of made-to-order products. The balance of the payment must be settled in full prior to shipment.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Stocked Standard Items</li>
                <div>For stocked standard items, 100% payment is required before shipment.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Storage Costs</li>
                <div>Storage, due to insurance and space constraints, cannot be provided longer than 2 weeks from order completion and notification. Storage of purchased goods beyond 2 weeks may be billed at a weekly rate of $250.  If the balance of an order has not been paid after 18 weeks then Meljac North America has the right to retain the products and order deposit.</div>
              </ol>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>5. ORDER ISSUES</Text>
              <Text>Customers have a 14-day window from the date of delivery to raise any issues or discrepancies related to their order. Issues reported after this period may not be accepted for after-service resolution.</Text>
            </View>
          </View>
        ),
        termsAndConditionsDisclaimerPage2: (
          <View>
            <Text style={{...style.pageTitle}}>TERMS AND CONDITIONS OF SALE CONTINUED</Text>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>6. RETURNS AND EXCHANGES</Text>
              <ol type="a" style={{...style.orderedList}}>
                <li style={{...style.orderedListItem}}>Made-to-Order Products</li>
                <div>All made-to-order products are non-returnable and non-exchangeable. This policy applies to any items manufactured to customer specifications.</div>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Stocked Standard Back Boxes</li>
                <div>Non-custom, stocked back boxes can be returned or exchanged within 30 days of delivery. However, such returns or exchanges are subject to a 25% restocking fee.</div>
              </ol>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>7. FINISHES</Text>
              <ol type="a" style={{...style.orderedList}}>
                <li style={{...style.orderedListItem}}>Unlacquered Finishes</li>
                <Text>Unlacquered finishes, including those with a wax varnish, will naturally develop a patina over time. These finishes are subject to immediate surface changes, including microscratches and oxidation. It is possible for these effects to occur during the shipping and installation processes. As such, they cannot be considered as a defect. Projects selecting unlacquered finishes should expect such details to be part of the character of their plates.</Text>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Custom Matching</li>
                <Text>Any custom finish matching will be based on a sample provided by Meljac North America. The customer must approve this sample before proceeding with the order.  Custom finishes are subject to pricing variations that may only be confirmed after the finish has been approved.</Text>
                <li style={{...style.orderedListItem, marginTop: K.margin / 2}}>Finish Consistency</li>
                <Text>Due to their handcrafted nature using traditional methods, plate finishes involving patination and/or burnishing are subject to natural variations. Meljac and Meljac North America make all efforts to ensure a reasonable level of consistency amongst review samples and orders but cannot guarantee complete uniformity. If uniformity is a concern, please discuss requirements with your MNA sales representative prior to confirming your order.</Text>
              </ol>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>8. WARRANTY</Text>
              <Text>Meljac North America guarantees its products against defects in design, materials, or manufacturing for 24 months after receipt, not installation. To make a warranty claim, the purchaser must provide a detailed explanation of the issue along with images. Meljac North America may request the return of the defective product for inspection at our factory.</Text>
              <Text style={{marginTop: K.margin}}>Meljac North America is not responsible for the following:</Text>
              <ul style={{...style.unorderedList}}>
                <li style={{...style.unorderedListItem}}>Damage caused by improper cleaning methods or solutions</li>
                <li style={{...style.unorderedListItem}}>Damage caused by exposure to weather or inappropriate environment</li>
                <li style={{...style.unorderedListItem}}>Damage caused by exterior installations</li>
                <li style={{...style.unorderedListItem}}>Damage caused by improper installation</li>
                <li style={{...style.unorderedListItem}}>Changes in appearance to unlacquered finishes</li>
                <li style={{...style.unorderedListItem}}>Any costs of installation or removal</li>
              </ul>
            </View>

            <View style={{...style.section}}>
              <Text style={{...style.sectionTitle}}>9. CARE INSTRUCTIONS</Text>
              <ul style={{...style.unorderedList}}>
                <li style={{...style.unorderedListItem}}>Never use a chemical cleaner to clean Meljac plates.</li>
                <li style={{...style.unorderedListItem}}>Plates can be cleaned with a damp dust rag or microfiber, followed by a dry one.</li>
                <li style={{...style.unorderedListItem}}>Select finishes are unlacquered and hand-sealed with a light layer of wax.  To maintain appearance, clients may choose to periodically reapply a metal finishing wax to their plates. </li>
                <li style={{...style.unorderedListItem}}>The use of brass cleaners on unlacquered polished brass is recommended if clients wish to maintain a bright and polished appearance.  Using brass cleaners on any other finish will remove the patina and alter the finish permanently.</li>
              </ul>
            </View>
          </View>
        )
      };
    }

    return (
      <Text
        style={{
          ...K.fonts.standard,
          paddingTop: K.margin,
          paddingBottom: K.margin,
          opacity: 0.7,
        }}
      >
        {disclaimers[disclaimerType]}
      </Text>
    );
  }
}
